import React, {Component} from 'react';

class LineBreak extends Component{
    static defaultProps = {
        content:'',
        className:null
    }
    render(){
        return (
            <div className={this.props.className}>
            { (this.props.content!==null && this.props.content!=='') &&
                this.props.content.split('\n').map(
                (row, key) => {
                    return (<p key={key}>{row}</p>);
                }
                )
                }
            </div>
        );
    }//render
}//class

export default LineBreak;